import React, { createContext, useState, useEffect, useContext } from "react";

export const MachineContext = createContext();

export const MachineProvider = ({ children }) => {
  const [machines, setMachines] = useState([]);

  const apiUrl = process.env.REACT_APP_MONGO_URL;

  useEffect(() => {
    if (!apiUrl) {
      return null;
    }
    fetch(`${apiUrl}/api/machines`)
      .then((response) => response.json())
      .then((data) => setMachines(data))
      .catch((error) => console.error("Makine verisi alınamadı:", error));
  }, [apiUrl]);

  const getMachineById = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/machines/${id}`);
      if (!response.ok) {
        throw new Error("Makine bulunamadı!");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Hata:", error);
      return null;
    }
  };

  const addMachine = (newMachine) => {
    fetch(`${apiUrl}/api/machines/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newMachine),
    })
      .then((response) => response.json())
      .then((data) => {
        setMachines((prev) => [...prev, data]);
      })
      .catch((error) => {
        console.error("Ekleme hatası:", error);
      });
  };

  const updateMachine = (id, updatedData) => {
    fetch(`${apiUrl}/api/machines/update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    })
      .then((response) => response.json())
      .then((updatedMachine) => {
        setMachines((prev) =>
          prev.map((machine) => (machine._id === id ? updatedMachine : machine))
        );
      })
      .catch((error) => {
        console.error("Güncelleme hatası:", error);
      });
  };

  const deleteMachine = (id) => {
    // Önce UI'de listeyi filtrele
    setMachines((prev) => prev.filter((department) => department._id !== id));

    // API isteği gönder
    fetch(`${apiUrl}/api/machines/${id}`, {
      method: "DELETE",
    }).catch((error) => {
      console.error("Silme hatası:", error);
    });
  };

  return (
    <MachineContext.Provider
      value={{
        machines,
        getMachineById,
        deleteMachine,
        addMachine,
        updateMachine,
      }}
    >
      {children}
    </MachineContext.Provider>
  );
};

export const useMachines = () => useContext(MachineContext);
